export const SUPPLIER_SPEND_VENUE_CONFIRM_COUNT = 40

export const shouldConfirmSupplierSpendSize = count =>
  Number(count) > SUPPLIER_SPEND_VENUE_CONFIRM_COUNT

export const supplierSpendLargeGroupQuestion = count =>
  `This supplier spend report has ${count} venues. Load their suppliers now?`

export const supplierSpendProgressLine = (index, total) =>
  `Venue ${index} of ${total}`

export const canRunSupplierSpend = ({
  venueCount,
  supplierCount,
  loadingSuppliers,
  hasDates,
} = {}) =>
  !loadingSuppliers &&
  Number(venueCount) > 0 &&
  Number(supplierCount) > 0 &&
  Boolean(hasDates)

export const loadSuppliersInOrder = async (
  venueIds,
  fetchSuppliers,
  onVenue,
) => {
  const responses = []
  const ids = venueIds || []
  for (let index = 0; index < ids.length; index += 1) {
    if (onVenue) onVenue(index + 1, ids.length)
    responses.push(await fetchSuppliers(ids[index]))
  }
  return responses
}
